'use client';

import { Account, Compare } from '@velocity-exchange/icons';
import Button from 'src/components/primitives/Button/Button';
import useModal from 'src/components/Modals/hooks/useModal';
import useGoToRoute from 'src/hooks/useGoToRoute';
import { useDrawersStore } from 'src/stores/useDrawersStore';
import SideDrawer from '../BaseDrawers/SideDrawer/SideDrawer';
import useDriftAccountStore from 'src/stores/useDriftAccountsStore';

export function AccountsDrawerFooter() {
	const accounts = useDriftAccountStore((s) => s.accounts);
	const hasAccounts = Object.values(accounts).filter(Boolean).length > 0;
	const handleCloseDrawer = useDrawersStore((s) => s.handleCloseDrawer);
	const { show } = useModal();
	const goToRoute = useGoToRoute();

	const handleOpenAddAccountModal = () => {
		show({ type: 'new_subaccount', props: {} });
	};

	const handleRouteToManageAccts = () => {
		handleCloseDrawer('accounts');
		goToRoute('/portfolio/accounts');
	};

	if (!hasAccounts) return null;

	return (
		<SideDrawer.Footer className="flex flex-col gap-y-lg">
			<div className="flex w-full gap-x-sm">
				<Button
					size="md"
					variant="secondary"
					leftIcon={Account}
					onClick={handleOpenAddAccountModal}
					className="flex-1"
				>
					Add Account
				</Button>
				<Button
					size="md"
					variant="secondary"
					leftIcon={Compare}
					onClick={handleRouteToManageAccts}
					className="flex-1"
				>
					Manage Account
				</Button>
			</div>
		</SideDrawer.Footer>
	);
}
